import React from 'react';
import styled from 'styled-components/macro';
import chroma from 'chroma-js';
import { sizesMap, textLineHeight } from '../../typography/utils';
import { SPACINGS } from '../../utils';

export const MenuWrapper = styled.div`
  display: block;
`;

type PillProps = {
  size: 'sm' | 'base';
  selected: boolean;
};
export const Pill = styled.button<PillProps>`
  background-color: transparent;
  position: relative;
  outline: none;
  margin: 0;
  padding: 0 ${SPACINGS[2]};
  margin-right: ${(p) => (p.size === 'sm' ? SPACINGS[2] : SPACINGS[4])};
  margin-bottom: ${(p) => (p.size === 'sm' ? SPACINGS[2] : SPACINGS[4])};
  border: 1px solid ${(p) => p.theme.colors.secondary80w};
  border-radius: 8px;

  color: ${(props) => props.theme.colors.black};
  font-family: ${(props) => props.theme.fonts.gtEesti};
  font-size: ${(p) => sizesMap[p.size].size};
  line-height: ${textLineHeight};
  font-weight: 300;

  opacity: ${(props) => (props.disabled ? '0.2' : 1)};

  background-color: ${(p) =>
    p.selected ? chroma(p.theme.colors.primary).alpha(0.2).hex() : 'none'};

  cursor: pointer;
  &:disabled {
    cursor: not-allowed;
  }

  &:not(:disabled) {
    &:focus,
    &:active,
    &:hover {
      outline: none;
      border: 1px solid ${(p) => p.theme.colors.primary};
    }
  }
`;

type ItemWithParams = {
  disabled?: boolean;
  hidden?: boolean;
};

type PillMenuProps<I> = {
  items: I[];
  selectedItem: I;
  keyAccessor: (i: I) => string;
  labelAccessor: (i: I) => string;
  onChange: (i: I) => void;
  size?: 'sm' | 'base';
  style?: React.CSSProperties;
};

function PillMenu<I>(props: PillMenuProps<I & ItemWithParams>) {
  const {
    items,
    selectedItem,
    keyAccessor,
    labelAccessor,
    onChange,
    size = 'base',
    style,
  } = props;

  return (
    <MenuWrapper style={style}>
      {items.map((item) => {
        if (item.hidden) return null;
        return (
          <Pill
            size={size}
            disabled={item.disabled}
            selected={keyAccessor(item) === keyAccessor(selectedItem)}
            key={keyAccessor(item)}
            onClick={() => onChange(item)}
          >
            {labelAccessor(item)}
          </Pill>
        );
      })}
    </MenuWrapper>
  );
}

export default PillMenu;
